import { cardExclusiveUrl } from "@settings";

export const isCardExclusiveEnv = () => {
  return location.origin === cardExclusiveUrl;
};
